import {Map, fromJS} from 'immutable';

import dieselReducer from '../../decorators/DieselReducer';
import {PurchaseTypes} from '../actions/purchase.actions';

export const DEFAULT_STATE = fromJS({
    offers: Map(),
    purchaseInProgress: false,
    userDidClickPurchase: Map(),
    userDismissedCompatibiltyWarning: Map(),
    usersPlatformIsFullySupported: Map()
});

export const purchaseReducer = (state = DEFAULT_STATE, {type, payload}) => {
    switch (type) {
        case PurchaseTypes.SET_USERS_PLATFORM_IS_FULLY_SUPPORTED:
            return state.setIn(
                ['usersPlatformIsFullySupported', payload.productName],
                !!payload.usersPlatformIsFullySupported
            );
        case PurchaseTypes.SET_USER_DISMISSED_COMPATIBILITY_WARNING:
            return state.setIn(
                ['userDismissedCompatibilityWarning', payload.productName],
                !!payload.userDidDismissCompatibilityWarning
            );
        case PurchaseTypes.SET_USER_DID_CLICK_PURCHASE:
            return state.setIn(
                ['userDidClickPurchase', payload.productName],
                !!payload.userDidClickPurchase
            );
        case PurchaseTypes.AUTO_PURCHASE:
            return state.set('autoPurchase', payload.id);
        case PurchaseTypes.REMOVE_AUTO_PURCHASE:
            return state.set('autoPurchase', false);
        case PurchaseTypes.PURCHASE:
            return state.set('autoPurchase', false).set('activeProductName', payload.productName);
        case PurchaseTypes.PURCHASE_BEGIN:
            return state.set('purchaseInProgress', true).setIn(
                ['offers', payload.id],
                Map({
                    purchaseButtonDisabled: true,
                    purchaseSuccess: false
                })
            );
        case PurchaseTypes.PURCHASE_SUCCESS:
            return state.set('purchaseInProgress', false).setIn(
                ['offers', payload.id],
                Map({
                    purchaseButtonDisabled: false,
                    purchaseSuccess: true
                })
            );
        case PurchaseTypes.PURCHASE_FAILURE:
            return state.set('purchaseInProgress', false).setIn(
                ['offers', payload.id],
                Map({
                    purchaseButtonDisabled: false,
                    purchaseSuccess: false
                })
            );
        default:
            return state;
    }
};

export default dieselReducer('purchase', purchaseReducer);
